<template>
  <div class="suspensionTag">
    <div style="padding: 8px 0px 10px 0px;background-color: rgb(215, 215, 215);text-align: center;">
      <span style="font-size: 18px;">选中数据</span>
    </div>
    <el-table
      style="width: 100%;height:394px;overflow:auto;"
      :height="listHeight"
      ref="singleTable"
      :data="resultList"
      highlight-current-row
      :show-header="false"
      @row-contextmenu="rowContextmenu"
      @row-dblclick="detailedClick"
      @current-change="handleCurrentChange"
    >
      <el-table-column
        v-for="(column, index) in columns"
        :key="index"
        :property="column.value"
        :label="column.text"
        :width="column.width"
      ></el-table-column>
      <el-table-column align="left" width="60">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-close"
            circle
            @click="handleDelete(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="padding-bottom: 10px;margin-top: 10px;text-align: center;">
      <el-button type="primary" size="mini" @click="toSure">确认返回</el-button>
      <!-- <el-button type="primary" size="mini" @click="saveClick">存为模板</el-button> -->
      <!-- <el-button
        type="primary"
        size="mini"
        icon="el-icon-circle-check-outline"
        @click="saveClick"
      >保存</el-button>-->
      <!-- <el-button
        type="primary"
        size="mini"
        icon="el-icon-circle-close-outline"
        @click="deleteClick"
      >删除</el-button>-->
      <el-button type="info" size="mini" style="margin-left:10px;" @click="emptyClick">清空</el-button>
    </div>
    <createTemplate ref="createTemplate" :body="false" :temType="1"></createTemplate>
    <!-- 
      @name contextMenu
      @desc 右键菜单
      @param contextMenu table 选中行
    -->
    <contextMenu ref="contextMenu" :contextMenu="contextmenuRow" :isTask="false"></contextMenu>
  </div>
</template>

<script>
import createTemplate from "./createTemplate.vue";
import { mapState, mapMutations, mapGetters } from "vuex";
import { UpdateTemplate } from "@/api/modules/basicData/task";
export default {
  components: {
    createTemplate,
    contextMenu: () => import("@/views/task/common/contextmenu.vue"), //右键菜单
  },
  data() {
    return {
      nowRow: null,
      currentRow: null,
      contextmenuRow:{},
      listHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight - 1000, //（这里的240是减去表格上面导航和搜索条件的高度）
    };
  },
  created() {
    var a = $(window).height();
    this.listHeight = a - 350;
  },
  props: {
    // userId: String,
    //列配置
    columns: {
      type: Array,
      default: function () {
        return [
          // 列
          {
            text: "任务名称",
            value: "TASKNAME",
          },
        ];
      },
    },
    isDetailed: {
      //是否显示详情
      type: Boolean,
      default: true,
    },
    filedID: {
      type: String,
      default: "ID",
    },
  },
  computed: {
    ...mapState({
      resultList: (state) => state.resultBase.resultList,
      resultSelection: (state) => state.resultBase.resultSelection,
      isResult: (state) => state.resultBase.isResult,
      tagItem: (state) => state.task.tagItem,
      resultTagItem: (state) => state.task.resultTagItem,
      category: (state) => state.task.category,
    }),
  },
  watch: {
    listHeight(val) {
      if (!this.timer) {
        this.listHeight = val;
        this.timer = true;
        const that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
  methods: {
    ...mapMutations(["clearResult", "addResult", "deleteResultField"]),
    handleDelete(row) {
      console.log("删除当前行select:", row);
      // this.deleteResultField(row);
      this.addResult({ row: row, bol: false });
      // this.$emit('deleteResult',[row]);
      // // // alert(row[this.filedID])
      // this.deleteResultField({ id: row[this.filedID], filed: this.filedID });
      // if (this.resultList.length == 0) {
      //   this.$store.state.resultBase.isResult = false;
      // }
    },
    emptyClick() {
      console.log(this.resultList);
      let data = [];
      // this.$emit('deleteResult',this.resultList);
      // this.$store.commit("clearResult");
      this.clearResult(data);
    },
    saveClick() {
      // 存为模板
      console.log(this.resultList);
      console.log(this.tagItem, "tagItem");
      // return false
      let idArr = [];
      this.resultList.forEach((c) => {
        idArr.push(c[this.filedID]);
      });
      if (this.isResult) {
        this.$confirm("请选择", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "创建新模板", //确定
          cancelButtonText: "保存到原模板", //删除
          type: "warning",
        })
          .then(() => {
            this.$refs.createTemplate.open();
            if (
              this.category == 12 ||
              this.category == 13 ||
              this.category == 16
            ) {
              // 团队类型传入json
              let content = [];
              this.resultList.forEach((res) => {
                content.push({
                  ID: res.SocialId,
                  Type: res.Type,
                });
              });
              this.$refs.createTemplate.content = JSON.stringify(content);
            } else if (this.category == 6) {
              let content = [];
              this.resultList.forEach((res) => {
                content.push({
                  ID: res.ID,
                  Type: res.Type,
                });
              });
              this.$refs.createTemplate.content = JSON.stringify(content);
            } else {
              this.$refs.createTemplate.content = idArr.join(",");
            }
          })
          .catch((action) => {
            if (action === "cancel") {
              let obj = this.resultTagItem;
              console.log("resultTagItem", this.resultTagItem);
              if (this.category == 6) {
                let content = [];
                this.resultList.forEach((res) => {
                  content.push({
                    ID: res.ID,
                    Type: res.Type,
                  });
                });
                obj.CONTENT = JSON.stringify(content);
              } else {
                obj.CONTENT = idArr.join(",");
                console.log(obj, "obj");
              }
              UpdateTemplate(obj, this.category).then((res) => {
                console.log(res);
                if (res == 1) {
                  this.$message({
                    type: "success",
                    message: "保存成功",
                  });
                }
              });
            }
          });
      } else {
        this.$refs.createTemplate.open();
        if (this.category == 12 || this.category == 13 || this.category == 16) {
          // 团队类型传入json
          let content = [];
          this.resultList.forEach((res) => {
            content.push({
              ID: res.SocialId,
              Type: res.Type,
            });
          });
          this.$refs.createTemplate.content = JSON.stringify(content);
        } else if (this.category == 6) {
          let content = [];
          this.resultList.forEach((res) => {
            content.push({
              ID: res.ID,
              Type: res.Type,
            });
          });
          this.$refs.createTemplate.content = JSON.stringify(content);
        } else {
          this.$refs.createTemplate.content = idArr.join(",");
        }
      }
    },
    toSure() {
      this.$emit("getValue", this.resultList, function (str) {
        //传递值，无论是否验证
        // isValidate = str;
      });
      // this.$parent.getValue(this.resultList);
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange(row) {
      //当前行事件
      // console.log('当前：', row);
      this.nowRow = row;
      this.$store.commit("setResultSelection", row);
    },
    detailedClick() {
      //查看详情
      // 				this.$store.commit('changeTaskSource', this.resultList);
      // 				this.$store.commit('changeTotalCount', this.resultList.length);
      if (this.nowRow) {
        this.$emit("detailsEvent", this.resultSelection, function (str) {});
      }
    },
    deleteClick() {
      //删除当前行
      if (!this.resultSelection) {
        this.$message({
          type: "info",
          message: "请选择需要删除行",
        });
        return;
      }
      this.$store.commit("deleteResult", this.resultSelection.ID);
      if (this.resultList.length == 0) {
        this.$store.state.resultBase.isResult = false;
      }
    },
    addClick() {
      //创建结果集模板
      let idArr = [];
      this.resultList.forEach((c) => {
        idArr.push(c[this.filedID]);
      });
      this.$refs.createTemplate.open();
      this.$refs.createTemplate.content = idArr.join(",");
    },
    saveClick() {
      console.log(this.resultList);
      console.log(this.tagItem, "tagItem");
      // return false
      let idArr = [];
      this.resultList.forEach((c) => {
        idArr.push(c[this.filedID]);
      });
      if (this.isResult) {
        this.$confirm("请选择", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "创建新模板", //确定
          cancelButtonText: "保存到原模板", //删除
          type: "warning",
        })
          .then(() => {
            this.$refs.createTemplate.open();
            // this.$refs.createTemplate.userId = this.userId;
            if (this.category == 12 || this.category == 13) {
              // 团队类型传入json
              let content = [];
              this.resultList.forEach((res) => {
                content.push({
                  ID: res.SocialId,
                  Type: res.Type,
                });
              });
              this.$refs.createTemplate.content = JSON.stringify(content);
            } else {
              this.$refs.createTemplate.content = idArr.join(",");
            }
          })
          .catch((action) => {
            if (action === "cancel") {
              let obj = this.resultTagItem;
              obj.CONTENT = idArr.join(",");
              console.log(obj, "obj");
              // return false
              UpdateTemplate(obj, this.category).then((res) => {
                console.log(res);
                if (res == 1) {
                  this.$message({
                    type: "success",
                    message: "保存成功",
                  });
                }
              });
            }
          });
      } else {
        this.$refs.createTemplate.open();
        if (this.category == 12 || this.category == 13) {
          // 团队类型传入json
          let content = [];
          this.resultList.forEach((res) => {
            content.push({
              ID: res.SocialId,
              Type: res.Type,
            });
          });
          this.$refs.createTemplate.content = JSON.stringify(content);
        } else {
          this.$refs.createTemplate.content = idArr.join(",");
        }
      }
      // 				let idArr = [];
      // 				this.resultList.forEach((c) => {
      // 					idArr.push(c.ID)
      // 				})
      // 				this.$refs.createTemplate.open();
      // 				this.$refs.createTemplate.content = idArr.join(',')
    },
    /**
     * @method table右键点击显示菜单
     * @param {Object} [ row ] table右键点击行
     * @param {Object} [ column ] table右键点击列
     * @param {Object} [ event ] column ] 事件源
     */
    rowContextmenu(row, column, event) {
      console.log(row);
      event.preventDefault();

      const postition = {
        top: event.clientY,
        left: event.clientX,
      };

      this.contextmenuRow = row;
      this.$refs.contextMenu.Show(postition);
    },
  },
};
</script>

<style lang="less">
.suspensionTag {
  background: white;
  .el-button + .el-button {
    margin-left: 0px;
  }
  .el-button--mini,
  .el-button--mini.is-round {
    padding: 7px 10px;
  }
}
</style>
<style scoped>
</style>
